<template>
  <div
    v-if="!loading"
    class="page">
    <app-title :page="'Rate cards'">
      <div
        slot="content"
        class="flex-sm justify-content-space-between flex-end">
        <p class="font-size-4 mb1">Set your rates</p>
      </div>
    </app-title>
    <section
      v-if="rates.length"
      class="grid mb-margin">
      <div
        v-if="rates.length > 15"
        class="align-right"><button
          class="accent-button large-button full-button_mb mr2"
          @click="$router.push({ name: 'newRateSimple' })">Set a manual rate card</button> <button
            class="accent-button large-button full-button_mb"
            @click="$router.push({ name: 'newRateGeneral' })">Calculate your rate</button></div>
      <div class="subtle px2 py1 my1 listing">
        <lw-table
          :type="'lined'"
          :size="'c1'"
          :headings="[
            'Name',
            'Month',
            'Sprint',
            'Week',
            'Day',
            'Hour'
          ]"
          :alignment="[
            'left',
            'right',
            'right',
            'right',
            'right',
            'right'
          ]"
        >
          <tr
            v-for="rate in rates"
            :key="rate.id">
            <td class="title">
              <div v-if="rate.mloe || rate.type === 'Calculated'"><router-link
                :class="'mr1'"
                :to="{ name: 'rate', params: { id: rate.id }}">{{ rate.name }}</router-link> <span class="font-size-1 grey-600-text medium">{{ rate.type }}</span></div>
              <div v-else><router-link
                :class="'mr1'"
                :to="{ name: 'simpleRate', params: { id: rate.id }}">{{ rate.name }}</router-link> <span class="font-size-1 grey-600-text medium">{{ rate.type }}</span></div>
            </td>
            <td class="numerical">{{ rate.monthRate | currency }}</td>
            <td class="numerical">{{ rate.sprintRate | currency }}</td>
            <td class="numerical">{{ rate.weekRate | currency }}</td>
            <td class="numerical">{{ rate.dayRate | currency }}</td>
            <td class="numerical">{{ rate.hourRate | currency }}</td>
          </tr>
        </lw-table>
      </div>
      <div class="align-right"><button
        class="accent-button large-button full-button_mb mr2"
        @click="$router.push({ name: 'newRateSimple' })">Set a manual rate card</button> <button
          class="accent-button large-button full-button_mb"
          @click="$router.push({ name: 'newRateGeneral' })">Calculate your rate</button></div>
    </section>
    <section
      v-else
      class="grid mt2 mb-margin">
      <div><button
        class="accent-button large-button full-button_mb mr2"
        @click="$router.push({ name: 'newRateSimple' })">Set a manual rate card</button> <button
          class="accent-button large-button full-button_mb"
          @click="$router.push({ name: 'newRateGeneral' })">Calculate your rate</button></div>
    </section>
    <transition
      name="slide-top"
      mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import page from '../mixins/page'
import Table from '../livewires/Table.vue'

export default {
  components: {
    lwTable: Table
  },
  mixins: [ page ],
  computed: {
    ...mapActions(['setRatesRef']),
    ...mapGetters([
      'rates',
      'organization'
    ]),
    loading () {
      return this.$store.getters.ratesLoading
    }
  }
}
</script>

<style scoped>
  .listing {
    overflow-x: auto;
  }
</style>
